import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { apiPrefix, ConnectionService } from "./Connecion.service";

dayjs.extend(utc);
dayjs.extend(timezone);

const RESOURCE = 'auth/License';

class AuthLicenseService extends ConnectionService {

  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async getLicense(params) {
    const url = `${this.basedUrl}`;
    return super.sendRequest(url, { params }, true);
  }

  async getLicenseLog(params) {
    const url = `${this.basedUrl}/LicenseLog`;
    return super.sendRequest(url, { params }, true);
  }

  async generateLicenseLog(params) {
    const url = `${this.basedUrl}/LicenseLog/download`;

    const localTimezone = dayjs();
    const config = {
      encode: false,
      params: {
        mspId: params.orgId,
        fromDate: params.fromDate,
        toDate: params.toDate,
        timezone: localTimezone.format('Z')
      }
    };

    return super.sendRequest(url, config, true);
  }

  async getLicenseLogUrl(params) {
    const url = `${this.basedUrl}/LicenseLog/download/url`;
    return super.sendRequest(url, { params }, true);
  }

  async getLicenseLogCsv(params) {
    const url = `${this.basedUrl}/LicenseLog/Csv`;

    const localTimezone = dayjs();
    const config = {
      encode: false,
      params: {
        orgId: params.orgId,
        fromDate: params.fromDate,
        toDate: params.toDate,
        timezone: localTimezone.format('Z')
      }
    };

    return super.sendRequest(url, config, true, 'text');
  }

  async getLicense(params) {
    const url = `${this.basedUrl}`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspOverview(params) {
    const url = `${this.basedUrl}/mspOverview`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspGenerateList(params) {
    const url = `${this.basedUrl}/mspOverview/download`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspGenerateListUrl(params) {
    const url = `${this.basedUrl}/mspOverview/download/url`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspOverviewHistory(params) {
    const url = `${this.basedUrl}/mspOverview/history`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspHistoryGenerateList(params) {
    const url = `${this.basedUrl}/mspOverview/history/download`;
    return super.sendRequest(url, { params }, true);
  }

  async getMspHistoryGenerateListUrl(params) {
    const url = `${this.basedUrl}/mspOverview/history/download/url`;
    return super.sendRequest(url, { params }, true);
  }

}

export default new AuthLicenseService();